// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"424":"eb645a87","964":"2995b68c"}[chunkId] + ".chunk.css";
};